import { LogLevel } from './types';
import { Capacitor } from '@capacitor/core';

// Extend Window interface to include _env_
declare global {
  interface Window {
    _env_?: Record<string, string>;
  }
}

export const LOG_CONFIG = {
  // Loki configuration
  loki: {
    enabled: true, // Enable Loki logging
    host: import.meta.env.VITE_LOKI_HOST,
    sourceName: import.meta.env.VITE_LOKI_SOURCE_NAME,
    auth: {
      username: import.meta.env.VITE_LOKI_USERNAME,
      password: import.meta.env.VITE_LOKI_PASSWORD,
    },
    // Control whether to send test logs
    sendTestLogs: import.meta.env.DEV || false, // Only send test logs in development by default
    labels: {
      platform: Capacitor.getPlatform(),
      environment: import.meta.env.MODE,
      version: import.meta.env.VITE_APP_VERSION,
    },
    retryOptions: {
      retries: 3, // Reduced from 5 for production
      minTimeout: 1000, // Reduced from 2000 for faster initial retry
      maxTimeout: 10000, // Reduced from 15000 for production
      factor: 2,
      onRetry: (error: any) => {
        // Only log retries in development
        if (import.meta.env.DEV) {
          console.warn('Retrying Loki connection...', error);
        }
      },
    },
    batchOptions: {
      maxSize: 100, // Increased from 50 for production efficiency
      maxWaitTime: 15000, // Increased from 10000 for production
      onError: (error: any) => {
        // Only log batch errors in development
        if (import.meta.env.DEV) {
          console.error('Loki batch error:', error);
        }
      },
    },
  },
  
  // General logging configuration
  general: {
    // Minimum log level to record based on environment
    minLogLevel: import.meta.env.PROD ? LogLevel.WARN : LogLevel.INFO, // Only log warnings and errors in production
    // Whether to also log to console
    enableConsole: import.meta.env.DEV,
    // Buffer size for batch sending
    batchSize: import.meta.env.PROD ? 20 : 5, // Larger batch size in production for efficiency
    // Flush interval in milliseconds
    flushInterval: import.meta.env.PROD ? 10000 : 3000, // Longer flush interval in production
  },
  
  // Redaction patterns for sensitive data
  redactionPatterns: [
    { pattern: /password=.*/g, replacement: 'password=[REDACTED]' },
    { pattern: /token=.*/g, replacement: 'token=[REDACTED]' },
    { pattern: /apiKey=.*/g, replacement: 'apiKey=[REDACTED]' },
    { pattern: /auth=.*/g, replacement: 'auth=[REDACTED]' },
    { pattern: /bearer .*/gi, replacement: 'bearer [REDACTED]' },
    { pattern: /"password":\s*"[^"]*"/g, replacement: '"password":"[REDACTED]"' },
    { pattern: /"token":\s*"[^"]*"/g, replacement: '"token":"[REDACTED]"' },
    { pattern: /"apiKey":\s*"[^"]*"/g, replacement: '"apiKey":"[REDACTED]"' },
    { pattern: /"auth":\s*"[^"]*"/g, replacement: '"auth":"[REDACTED]"' },
  ],
}; 
